import { useTranslation } from "react-i18next"
import { Button } from "../ui/button"

export interface UnknownErrorProps {
	error?: Error
	reset: () => void
}

export function UnknownError({ error, reset }: UnknownErrorProps) {
	const { t } = useTranslation()
	return (
		<div className="min-h-screen flex items-center justify-center bg-background">
			<div className="text-center p-6">
				<h2 className="text-xl font-semibold text-destructive mb-2">
					{t("unknown-error.title")}
				</h2>
				<p className="text-muted-foreground mb-4">
					{error instanceof Error
						? error.message
						: t("unknown-error.description")}
				</p>
				<Button onClick={reset} variant="default">
					{t("unknown-error.retry")}
				</Button>
			</div>
		</div>
	)
}
